import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import http from '../components/http/http';
import { useTranslation } from 'react-i18next';
import { refreshPromStatusExternally } from '../components/prom/usePromStatus';

const Login: React.FC = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const data = await http.post('/api/users/auth/login', { email, password, rememberMe });
      if (!data.success) {
        setError(data.error || data.message || t('loginFailed'));
        setLoading(false);
        return;
      }
      // Save tokens
      if (rememberMe) {
        localStorage.setItem('accessToken', data.accessToken);
        localStorage.setItem('user', JSON.stringify(data.user));
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('user');
      } else {
        sessionStorage.setItem('accessToken', data.accessToken);
        sessionStorage.setItem('user', JSON.stringify(data.user));
        localStorage.removeItem('accessToken');
        localStorage.removeItem('user');
      }
      setLoading(false);
      await refreshPromStatusExternally();
      navigate('/home');
    } catch (err: any) {
      setError(t('networkError'));
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: '60px auto', padding: 24, border: '1px solid #eee', borderRadius: 8, background: '#fff' }}>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ fontFamily: 'Roboto, sans-serif' }}>{t('login')}</h2> 
      </div>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16, width: '100%'  }}>
          <label>{t('email')}<br />
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{ width: '100%', padding: 8, marginTop: 4, fontSize: 14 }}
            />
          </label>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>{t('password')}<br />
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{ width: '100%', padding: 8, marginTop: 4, fontSize: 14 }}
            />
          </label>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'row-reverse', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={e => setRememberMe(e.target.checked)}
              style={{ marginRight: 0, width: 'auto', fontSize: 14 }}
            />
            {t('rememberMe')}
          </label>
        </div>
        {error && <div style={{ color: 'red' }}>{error}</div>}
        <div style={{ marginBottom: 16 }}>
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              height: '39px',
              background: '#3baab0',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              fontWeight: 600,
              fontSize: 16,
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.2s',
              opacity: loading ? 0.7 : 1
            }}
            onMouseOver={e => (e.currentTarget.style.background = '#329a9e')}
            onMouseOut={e => (e.currentTarget.style.background = '#3baab0')}
          >
            {loading ? t('loggingIn') : t('login')}
          </button>
        </div>
      </form>
      <div style={{ textAlign: 'right', marginTop: 8 }}>
        <a href="/forgot-password" style={{ color: '#3baab0', textDecoration: 'none', fontWeight: 500 }}
          onMouseOver={e => (e.currentTarget.style.textDecoration = 'underline')}
          onMouseOut={e => (e.currentTarget.style.textDecoration = 'none')}
        >
          {t('forgotPassword')}
        </a>
      </div>
      <div style={{ textAlign: 'center', marginTop: 24, display: 'flex', flexDirection: 'column' }}>
        <span style={{ color: '#888', marginRight: 8 }}>{t('dontHaveAnAccount')}</span>
        <Link to="/register">
          <button
            style={{
              marginTop: 0,
              padding: '8px 20px',
              background: '#fff',
              color: '#3baab0',
              border: '2px solid #3baab0',
              borderRadius: 4,
              fontWeight: 600,
              fontSize: 16,
              cursor: 'pointer',
              transition: 'background 0.2s, color 0.2s',
            }}
            onMouseOver={e => {
              e.currentTarget.style.background = '#3baab0';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseOut={e => {
              e.currentTarget.style.background = '#fff';
              e.currentTarget.style.color = '#3baab0';
            }}
          >
            {t('signUp')}
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Login; 